import { TileRoleRoute } from '@/types'
import { faTrafficLight } from '@fortawesome/free-solid-svg-icons'
import { ManagementGridFactory } from '@/routes/admin/components/ManagementGrid/ManagementGridFactory'
import { Roles } from '@/auth/azure/Roles'
import React from 'react'

export const EstStatoNoleggioRoute: TileRoleRoute = {
  path: 'eststatonoleggio',
  text: 'Stati Noleggio Est.',
  faIcon: faTrafficLight,
  element: (
    <ManagementGridFactory
      entity="est_stato_noleggio"
      referencesCollection={'licenze_est'}
      referencesTitle="Stati Noleggio licenze Est."
      displayField="id"
    />
  ),
  handle: {
    crumb: () => ({
      label: 'Stati Noleggio Est.',
      icon: faTrafficLight,
    }),
  },
  mainMenuRoute: false,
  tile: true,
  allowedRoles: [Roles.GlobalAdministrator],
}
